import { DropdownFilterItem } from '@tablesready/common-ui';
import { EnabledDisabledFilterEnum } from '../models';

export const availabilityFilters: DropdownFilterItem<EnabledDisabledFilterEnum>[] = [
  {value: EnabledDisabledFilterEnum.enabled, title: 'Enabled'},
  {value: EnabledDisabledFilterEnum.disabled, title: 'Disabled'},
];
